const f = {
  color: {
    initials: {
      bg: "#dfe6ebff",
      text: "#556575ff",
      textLight: "white",
      light: "#c8d3deff"
    },
    circle: {
      outer: "#d1e8ffff",
      inner: "#304ddbff"
    }
  }
};
export {
  f as avatar
};
